import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface PromoFiltersProps {
  merchantNameFilter: string
  setMerchantNameFilter: (v: string) => void
  activeOnly: boolean
  setActiveOnly: (v: boolean) => void
}

const PromoFilters = ({ merchantNameFilter, setMerchantNameFilter, activeOnly, setActiveOnly }: PromoFiltersProps) => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={2} sx={{ alignItems: 'center', mb: 2 }}>
      <Grid>
        <TextField
          value={merchantNameFilter}
          onChange={(e) => setMerchantNameFilter(e.target.value)}
          label={t('common.search')}
          placeholder={t('merchant.name')}
          size="small"
          sx={{ minWidth: 180, mr: 2 }}
          autoFocus
        />
      </Grid>
      <Grid>
        <FormControlLabel
          control={
            <Checkbox
              checked={activeOnly}
              onChange={(e) => setActiveOnly(e.target.checked)}
            />
          }
          label={t('browsePromotions.filters.activePromosOnly')}
        />
      </Grid>
    </Grid>
  )
}

export default PromoFilters
